import Vue from 'vue'
import Vuex from 'vuex'

const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

fb.auth.useDeviceLanguage();
fb.auth.setPersistence('session')
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserData')

    }
})

export const store = new Vuex.Store({
    state: {
        currentUser: null,
        userData: {},
        userImage: require('@/assets/user_profile.png'),
        languages: [
            { code: 'es', name: 'Español' },
            { code: 'en', name: 'English' }
        ],
        actionCodeSettings: {
            url: 'https://maintenance-19c7a.firebaseapp.com/',
            handleCodeInApp: true
        },
        devices: [],
        logs: []

    },
    actions: {
        clearData({ commit }) {
            commit('setCurrentUser', null)
            commit('setUserData', {})
        },

        fetchUserData({ commit, state }) {
            fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
                commit('setUserData', res.data())
            }).catch(err => {
                console.log(err)
            })
        },

        getDevices({ commit, state }) {
            fb.devicesCollection.orderBy('createdAt', 'desc').onSnapshot(function(querySnapshot) {
                querySnapshot.forEach(doc => {
                    let obj = doc.data()
                    obj.id  = doc.id
                    store.commit('setDevice', obj)
                })
            })
        },

        getLogs({ commit, state }, payload) {
            let logsQuery =  fb.devicesCollection.doc(payload.id);
            logsQuery.collection("logs").orderBy('timestamp', 'desc').limit(50).onSnapshot(function(querySnapshot) {
                let logs = []
                querySnapshot.forEach(doc => {
                    let obj = doc.data()
                    obj.id  = doc.id
                    logs.push(obj);
                })
                store.commit('setLog', logs)
            })
        },

        updateDevice({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                fb.devicesCollection.doc(data.id).update(data.fields).then(device => {
                    console.log('device updated');
                    resolve(device)
                }).catch(err => {
                    reject(err);
                })
            })
        },

        updateProfile({ commit, state }, data) {
            fb.usersCollection.doc(state.currentUser.uid).update(data).then(user => {
                console.log('user profile updated');
            }).catch(err => {
                console.log(err)
            })
        },

    },
    mutations: {
        setDevice(state, device){
            let index = state.devices.findIndex(x => x.id === device.id);
            if(index < 0){
                state.devices.push(device);
            } else {
                Vue.set(state.devices,index,device);
            }
        },
 
        setLog(state, logs){
            state.logs = logs
            //Vue.set(state.logs,index,device);
        },
        setCurrentUser(state, val) {
            state.currentUser = val
        },
        setUserData(state, val) {
            state.userData = val
        }
    },
    getters: {
        getTrackerlById: (state) => (id) => {
            return state.trackers.find(tracker => tracker.id === id)
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js